import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ITableInputWidget } from './ITableInputWidget.ts';
import { TableInputContainer } from './render/TableInputContainer.tsx';

export interface ITableInputWidgetProps
  extends IWidgetComponentProps<ITableInputWidget> {}

export function TableInputWidgetComponent(props: ITableInputWidgetProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <TableInputContainer {...props} options={options}>
      {props.children}
    </TableInputContainer>
  );
}
